// extracted by mini-css-extract-plugin
export default {"button":"BackToTop_button__IaPLr","visible":"BackToTop_visible__bax7V"};